import * as React from 'react';
import { Box, Button, Image } from '@enaep-ng/benchmark';
import * as styleSheet from '../styles';
import ExitApp from '../img/exitApp.svg';
import ExitAppV2 from '../img/exit-app-v2.svg';
import wifiSolid from '../img/wifi.svg';
import wifiOff from '../img/no-wifi.svg';
import batteryWarning from '../img/batt-warn.svg';
import batteryCharge from '../img/batt-charge.svg';
import { BatteryStateType, ConnectionType } from '../types';
import home from '../img/home.svg';
// Note - Layout of Exit Icon is slightly different than the previous react-bootstrap-icon, so keeping it here in case we need to change it back.
const ExitIcon = (props: { onExit: () => void }) => {
  return (
    // <BoxArrowInRight
    //   style={styleSheet.actionArrowIconStyle}
    //   onClick={props.onExit}
    //   title="Exit Application"
    // />
    <Button
      style={styleSheet.exitAppIconStyle}
      sx={{
        '& img': {
          width: 'calc(32px * var(--zoom))',
          height: 'calc(32px * var(--zoom))',
          display: 'inline-block',
        },
        label: 'Exit Application',
      }}
      onClick={props.onExit}
    >
      <Image src={ExitApp} />
    </Button>
  );
};

const ExitIconV2 = (props: { onExit: () => void,enabled?:boolean, title:string }) => {
  return (
      <Button
        style={props.enabled ? styleSheet.exitAppIconStyleV2 : styleSheet.exitAppIconStyleV2Disabled}
        sx={{
          '& img': {
            display: 'inline-block',
          },
          label: 'Exit Application',
        }}
        isDisabled={!props.enabled}
        onClick={props.onExit}
      >
        {props.title}
        <Box sx={styleSheet.exitIconV2}>
          <Image src={ExitAppV2} imgHeight={23} imgWidth={22}/>
        </Box>
      </Button>
  );
};

const HomeIconV2 = (props: { onHome: () => void,enabled?:boolean, title?:string }) => {
  return (
      <Button
        style={props.enabled ? styleSheet.homeButtonV2 : styleSheet.homeButtonV2Disabled}
        variant="bare"
        sx={{
          '& img': {
            display: 'inline-block',
          },
          label: 'Go to home page',
        }}
        isDisabled={!props.enabled}
        onClick={props.onHome}
      >
        {props.title}
        <Box sx={{ paddingTop: 'calc(9px * var(--zoom))' }}>
          <Image src={home} imgHeight={19} imgWidth={24} style={{backgroundColor: "#171c66"}}/>
        </Box>
      </Button>
  );
};

const ConnectionIcon = (props: { state: ConnectionType[] }) => {
  const ConnectionStateTypeIcon = (
    state: ConnectionType,
  ): React.ReactNode => {
    switch (state) {
      case 'Connected':
        return <Image style={styleSheet.wifiIconStyle} src={wifiSolid} />;
      case 'N/A':
        return (<><svg style={styleSheet.wifiIconStyle} id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 222.08 158.05"><defs></defs><g id="Layer_1-2"><path className="cls-1" d="M49.28,158.05c-2.3,0-4.61-.88-6.36-2.64-3.51-3.51-3.51-9.21,0-12.73L182.97,2.64c3.52-3.52,9.21-3.52,12.73,0,3.51,3.51,3.51,9.21,0,12.73L55.64,155.42c-1.76,1.76-4.06,2.64-6.36,2.64Z"/><path className="cls-1" d="M126.31,133.05h-29.91l-5.92,5.92c.14,1.31.77,2.6,2.01,3.58l13.26,7.95c1.32.69,2.79,1.05,4.27,1.05h2.04c1.49,0,2.96-.36,4.27-1.05l13.26-7.95c3.97-3.12,1.76-9.5-3.29-9.5Z"/><path className="cls-1" d="M151.87,99.79c-5.92-1.81-11.94-3.2-18-4.21l-17.12,17.12c9.98.47,19.92,2.18,29.59,5.14.92.28,1.85.42,2.77.42,4.04,0,7.78-2.61,9.02-6.68,1.53-4.98-1.27-10.26-6.26-11.79Z"/><path className="cls-1" d="M41.13,87.66c1.33,0,2.68-.28,3.96-.88,15.97-7.41,32.48-12.06,49.26-13.92l19.76-19.76c-1.02-.02-2.04-.04-3.07-.04-25.28,0-50.14,5.58-73.89,16.59-4.73,2.19-6.79,7.8-4.59,12.53,1.6,3.44,5.01,5.47,8.57,5.47Z"/><path className="cls-1" d="M184.93,69.66c-5.91-2.74-11.89-5.15-17.93-7.21l-15.09,15.09c8.48,2.35,16.85,5.43,25.09,9.25,4.73,2.19,10.34.14,12.53-4.59,2.19-4.73.14-10.34-4.59-12.53Z"/><path className="cls-1" d="M138.29,28.93l16.28-16.28c-14.32-3.02-28.85-4.57-43.52-4.57-36.62,0-72.34,9.47-106.17,28.15-4.56,2.52-6.22,8.26-3.7,12.82,1.72,3.12,4.95,4.88,8.27,4.88,1.54,0,3.11-.38,4.55-1.18,31-17.12,63.65-25.8,97.04-25.8,9.14,0,18.23.67,27.25,1.97Z"/><path className="cls-1" d="M217.21,36.24c-5.27-2.91-10.6-5.57-15.96-8.04l-14.32,14.32c7.13,2.99,14.18,6.39,21.15,10.24,4.56,2.52,10.3.86,12.83-3.7,2.52-4.56.86-10.3-3.7-12.82Z"/></g></svg></>)
        // return <Image style={styleSheet.wifiIconStyle} src={wifiOff} />;
      default:
        return <Image style={styleSheet.wifiIconStyle} src={wifiOff} />;
    }
  };
  return (
    <>
      {props.state.map((ConnectionType, index) => (
        <span key={index}>{ConnectionStateTypeIcon(ConnectionType)}</span>
      ))}
    </>
  );
};


const BatteryLevelIcon = (props: BatteryStateType) => {
  const { v2Check = false } = props;
  const [level, setLevel] = React.useState<number>();
  React.useEffect(() => {
    if ('getBattery' in navigator) {
      (navigator as any).getBattery().then((battery: any) => {
        setLevel(Math.floor(battery.level * 100));

        battery.addEventListener('levelchange', () => {
          setLevel(Math.floor(battery.level * 100));
        });
      });
    }
  }, []);

  const batteryState = (): React.ReactNode => {
    switch (props.state) {
      case 'Charging':
        // Battery Charging
        return (
          <Box
            title={`Charging at ${level}%`}
            style={{
              display: 'inline-block',
              margin: '0 calc(10px * var(--zoom)) 0 0',
            }}
            sx={v2Check ? styleSheet.iconsAltPosV2 : ''}
          >
            <svg
              style={styleSheet.batteryIconStyle}
              width="24px"
              height="24px"
              strokeWidth="1.4"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              color="#000000"
            >
              <path
                d="M23 10V14"
                stroke="#000000"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M1 16V8C1 6.89543 1.89543 6 3 6H18C19.1046 6 20 6.89543 20 8V16C20 17.1046 19.1046 18 18 18H3C1.89543 18 1 17.1046 1 16Z"
                stroke="#000000"
                strokeWidth="1.4"
              ></path>

              <rect
                x="2.5"
                y="8"
                // Note - 70% is the width of the battery Icon's available space inside.
                // Level is the values which will be fetched from device. So these two (Bettery Level and below Width properties) are different things.
                width={`${((level? level as number : 0) / 100) * 66}%`}
                height="8"
                fill="#000"
              />
              <path
                d="M10.1667 9L8.5 12H12.5L10.8333 15"
                stroke="#ffffff"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </Box>
        );
      case 'Full':
        // Battery Level
        return (
          <Box
            title={`${level}%`}
            style={{
              backgroundWidth: ``,
              display: 'inline-block',
              margin: '0 calc(10px * var(--zoom)) 0 0',
            }}
            sx={v2Check ? styleSheet.iconsAltPosV2 : ''}
          >
            <svg
              style={styleSheet.batteryIconStyle}
              width="24px"
              height="24px"
              strokeWidth="1.4"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              color="#000000"
            >
              <path
                d="M23 10V14"
                stroke="#000000"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M1 16V8C1 6.89543 1.89543 6 3 6H18C19.1046 6 20 6.89543 20 8V16C20 17.1046 19.1046 18 18 18H3C1.89543 18 1 17.1046 1 16Z"
                stroke="#000000"
                strokeWidth="1.4"
              ></path>
              <rect
                x="2.5"
                y="8"
                // Note - 66% is the width of the battery Icon's available space inside.
                // Level is the values which will be fetched from device. So these two (Bettery Level and below Width properties) are different things.
                width={`${((level? level as number : 0) / 100) * 66}%`}
                height="8"
                fill="#000"
              />
            </svg>
          </Box>
        );
      case 'Half':
        // Battery Level
        return (
          <Box
            title={`${level}%`}
            style={{
              backgroundWidth: ``,
              display: 'inline-block',
              margin: '0 calc(10px * var(--zoom)) 0 0',
            }}
            sx={v2Check ? styleSheet.iconsAltPosV2 : ''}
          >
            <svg
              style={styleSheet.batteryIconStyle}
              width="24px"
              height="24px"
              strokeWidth="1.4"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              color="#000000"
            >
              <path
                d="M23 10V14"
                stroke="#000000"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M1 16V8C1 6.89543 1.89543 6 3 6H18C19.1046 6 20 6.89543 20 8V16C20 17.1046 19.1046 18 18 18H3C1.89543 18 1 17.1046 1 16Z"
                stroke="#000000"
                strokeWidth="1.4"
              ></path>
              <rect
                x="2.5"
                y="8"
                // Note - 70% is the width of the battery Icon's available space inside.
                // Level is the values which will be fetched from device. So these two (Bettery Level and below Width properties) are different things.
                width={`${((level? level as number : 0) / 100) * 66}%`}
                height="8"
                fill="#000"
              />
            </svg>
          </Box>
        );
      case 'Danger':
        // Batter Warning
        return (
          <Box
            title={`${level}%`}
            style={{
              backgroundWidth: `${level}px`,
              display: 'inline-block',
              margin: '0 calc(10px * var(--zoom)) 0 0',
              verticalAlign: 'bottom',
            }}
          >
            <Image style={styleSheet.batteryIconStyle} src={batteryWarning} />
          </Box>
        );
      default:
        // Battery Level
        return (
          <Box
            title={`${level}%`}
            style={{
              backgroundWidth: ``,
              display: 'inline-block',
              margin: '0 calc(10px * var(--zoom)) 0 0',
            }}
            sx={v2Check ? styleSheet.iconsAltPosV2 : ''}
          >
            <svg
              style={styleSheet.batteryIconStyle}
              width="24px"
              height="24px"
              strokeWidth="1.4"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              color="#000000"
            >
              <path
                d="M23 10V14"
                stroke="#000000"
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M1 16V8C1 6.89543 1.89543 6 3 6H18C19.1046 6 20 6.89543 20 8V16C20 17.1046 19.1046 18 18 18H3C1.89543 18 1 17.1046 1 16Z"
                stroke="#000000"
                strokeWidth="1.4"
              ></path>
              <rect
                x="2"
                y="6.9"
                // Note - 70% is the width of the battery Icon's available space inside.
                // Level is the values which will be fetched from device. So these two (Bettery Level and below Width properties) are different things.
                width={`${((level? level as number : 0) / 100) * 70}%`}
                height="10"
                fill="#000"
              />
            </svg>
          </Box>
        );
    }
  };

  return <>{batteryState()}</>;
};

export { ConnectionIcon, BatteryLevelIcon, ExitIcon, ExitIconV2, HomeIconV2 };
